"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var breakpoints = ['hide', '5', '10', '15', '16', '20', '25', '30', '33', '35', '40', '45', '50', '55', '60', '65', '66', '70', '75', '80', '85', '90', '95', '100', 'min', 'max', 'auto', ''];

function sizeName(name, value) {
  var newClassName;

  if (value === 'max' || value === 'auto' || value === '') {
    newClassName = "co-grid__column".concat(name);
  } else if (value === 'hide') {
    newClassName = "co-grid__column--hidden".concat(name);
  } else {
    newClassName = "co-grid__column--".concat(value).concat(name);
  }

  return newClassName;
}

function Column(_ref) {
  var _gridClasses;

  var children = _ref.children,
      _ref$all = _ref.all,
      all = _ref$all === void 0 ? 'auto' : _ref$all,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      pushLeft = _ref.pushLeft,
      pushRight = _ref.pushRight,
      pushCenter = _ref.pushCenter,
      pushVcenter = _ref.pushVcenter,
      pushHcenter = _ref.pushHcenter,
      pushTop = _ref.pushTop,
      pushBottom = _ref.pushBottom,
      alignLeft = _ref.alignLeft,
      alignRight = _ref.alignRight,
      alignCenter = _ref.alignCenter,
      props = _objectWithoutProperties(_ref, ["children", "all", "small", "medium", "large", "pushLeft", "pushRight", "pushCenter", "pushVcenter", "pushHcenter", "pushTop", "pushBottom", "alignLeft", "alignRight", "alignCenter"]);

  var gridClasses = (_gridClasses = {
    'co-grid__column': true
  }, _defineProperty(_gridClasses, sizeName('', all), all), _defineProperty(_gridClasses, sizeName('@small', small), small), _defineProperty(_gridClasses, sizeName('@medium', medium), medium), _defineProperty(_gridClasses, sizeName('@large', large), large), _gridClasses);
  var allowedModifiers = {
    pushLeft: pushLeft,
    pushRight: pushRight,
    pushCenter: pushCenter,
    pushVcenter: pushVcenter,
    pushHcenter: pushHcenter,
    pushTop: pushTop,
    pushBottom: pushBottom,
    alignLeft: alignLeft,
    alignRight: alignRight,
    alignCenter: alignCenter
  };
  return _react.default.createElement(_styler.default, {
    classNames: gridClasses,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
}

var exclusiveTextAlignments = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('alignLeft', 'alignRight', 'alignCenter');
var exclusiveHorizontalValues = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('pushLeft', 'pushRight', 'pushCenter', 'pushHcenter');
var exclusiveVerticalValues = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('pushTop', 'pushBottom', 'pushCenter', 'pushVcenter');
Column.propTypes = {
  children: _propTypes.any.isRequired,

  /** {const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5 */
  all: (0, _propTypes.oneOf)(breakpoints),

  /** {const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5 */
  small: (0, _propTypes.oneOf)(breakpoints),

  /** {const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5 */
  medium: (0, _propTypes.oneOf)(breakpoints),

  /** {const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5 */
  large: (0, _propTypes.oneOf)(breakpoints),

  /** {bool} Mutually exclusive props: @@alignLeft@@ @@alignRight@@ @@alignCenter@@ */
  alignLeft: exclusiveTextAlignments,

  /** {bool} Mutually exclusive props: @@alignLeft@@ @@alignRight@@ @@alignCenter@@ */
  alignRight: exclusiveTextAlignments,

  /** {bool} Mutually exclusive props: @@alignLeft@@ @@alignRight@@ @@alignCenter@@ */
  alignCenter: exclusiveTextAlignments,

  /** {bool} Mutually exclusive props: @@pushLeft@@ @@pushRight@@ @@pushCenter@@ @@pushHCenter@@ */
  pushLeft: exclusiveHorizontalValues,

  /** {bool} Mutually exclusive props: @@pushLeft@@ @@pushRight@@ @@pushCenter@@ @@pushHCenter@@ */
  pushRight: exclusiveHorizontalValues,

  /** {bool} Mutually exclusive props: @@pushLeft@@ @@pushRight@@ @@pushCenter@@ @@pushHCenter@@ */
  pushHcenter: exclusiveHorizontalValues,
  pushCenter: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@pushTop@@ @@pushBottom@@ @@pushCenter@@ @@pushVcenter@@ */
  pushVcenter: exclusiveVerticalValues,

  /** {bool} Mutually exclusive props: @@pushTop@@ @@pushBottom@@ @@pushCenter@@ @@pushVcenter@@ */
  pushTop: exclusiveVerticalValues,

  /** {bool} Mutually exclusive props: @@pushTop@@ @@pushBottom@@ @@pushCenter@@ @@pushVcenter@@ */
  pushBottom: exclusiveVerticalValues
};
Column.displayName = 'Grid.Column';
var _default = Column;
exports.default = _default;
Column.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Grid.Column",
  "props": {
    "all": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'hide'",
          "computed": false
        }, {
          "value": "'5'",
          "computed": false
        }, {
          "value": "'10'",
          "computed": false
        }, {
          "value": "'15'",
          "computed": false
        }, {
          "value": "'16'",
          "computed": false
        }, {
          "value": "'20'",
          "computed": false
        }, {
          "value": "'25'",
          "computed": false
        }, {
          "value": "'30'",
          "computed": false
        }, {
          "value": "'33'",
          "computed": false
        }, {
          "value": "'35'",
          "computed": false
        }, {
          "value": "'40'",
          "computed": false
        }, {
          "value": "'45'",
          "computed": false
        }, {
          "value": "'50'",
          "computed": false
        }, {
          "value": "'55'",
          "computed": false
        }, {
          "value": "'60'",
          "computed": false
        }, {
          "value": "'65'",
          "computed": false
        }, {
          "value": "'66'",
          "computed": false
        }, {
          "value": "'70'",
          "computed": false
        }, {
          "value": "'75'",
          "computed": false
        }, {
          "value": "'80'",
          "computed": false
        }, {
          "value": "'85'",
          "computed": false
        }, {
          "value": "'90'",
          "computed": false
        }, {
          "value": "'95'",
          "computed": false
        }, {
          "value": "'100'",
          "computed": false
        }, {
          "value": "'min'",
          "computed": false
        }, {
          "value": "'max'",
          "computed": false
        }, {
          "value": "'auto'",
          "computed": false
        }, {
          "value": "''",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5"
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "small": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'hide'",
          "computed": false
        }, {
          "value": "'5'",
          "computed": false
        }, {
          "value": "'10'",
          "computed": false
        }, {
          "value": "'15'",
          "computed": false
        }, {
          "value": "'16'",
          "computed": false
        }, {
          "value": "'20'",
          "computed": false
        }, {
          "value": "'25'",
          "computed": false
        }, {
          "value": "'30'",
          "computed": false
        }, {
          "value": "'33'",
          "computed": false
        }, {
          "value": "'35'",
          "computed": false
        }, {
          "value": "'40'",
          "computed": false
        }, {
          "value": "'45'",
          "computed": false
        }, {
          "value": "'50'",
          "computed": false
        }, {
          "value": "'55'",
          "computed": false
        }, {
          "value": "'60'",
          "computed": false
        }, {
          "value": "'65'",
          "computed": false
        }, {
          "value": "'66'",
          "computed": false
        }, {
          "value": "'70'",
          "computed": false
        }, {
          "value": "'75'",
          "computed": false
        }, {
          "value": "'80'",
          "computed": false
        }, {
          "value": "'85'",
          "computed": false
        }, {
          "value": "'90'",
          "computed": false
        }, {
          "value": "'95'",
          "computed": false
        }, {
          "value": "'100'",
          "computed": false
        }, {
          "value": "'min'",
          "computed": false
        }, {
          "value": "'max'",
          "computed": false
        }, {
          "value": "'auto'",
          "computed": false
        }, {
          "value": "''",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5"
    },
    "medium": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'hide'",
          "computed": false
        }, {
          "value": "'5'",
          "computed": false
        }, {
          "value": "'10'",
          "computed": false
        }, {
          "value": "'15'",
          "computed": false
        }, {
          "value": "'16'",
          "computed": false
        }, {
          "value": "'20'",
          "computed": false
        }, {
          "value": "'25'",
          "computed": false
        }, {
          "value": "'30'",
          "computed": false
        }, {
          "value": "'33'",
          "computed": false
        }, {
          "value": "'35'",
          "computed": false
        }, {
          "value": "'40'",
          "computed": false
        }, {
          "value": "'45'",
          "computed": false
        }, {
          "value": "'50'",
          "computed": false
        }, {
          "value": "'55'",
          "computed": false
        }, {
          "value": "'60'",
          "computed": false
        }, {
          "value": "'65'",
          "computed": false
        }, {
          "value": "'66'",
          "computed": false
        }, {
          "value": "'70'",
          "computed": false
        }, {
          "value": "'75'",
          "computed": false
        }, {
          "value": "'80'",
          "computed": false
        }, {
          "value": "'85'",
          "computed": false
        }, {
          "value": "'90'",
          "computed": false
        }, {
          "value": "'95'",
          "computed": false
        }, {
          "value": "'100'",
          "computed": false
        }, {
          "value": "'min'",
          "computed": false
        }, {
          "value": "'max'",
          "computed": false
        }, {
          "value": "'auto'",
          "computed": false
        }, {
          "value": "''",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5"
    },
    "large": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'hide'",
          "computed": false
        }, {
          "value": "'5'",
          "computed": false
        }, {
          "value": "'10'",
          "computed": false
        }, {
          "value": "'15'",
          "computed": false
        }, {
          "value": "'16'",
          "computed": false
        }, {
          "value": "'20'",
          "computed": false
        }, {
          "value": "'25'",
          "computed": false
        }, {
          "value": "'30'",
          "computed": false
        }, {
          "value": "'33'",
          "computed": false
        }, {
          "value": "'35'",
          "computed": false
        }, {
          "value": "'40'",
          "computed": false
        }, {
          "value": "'45'",
          "computed": false
        }, {
          "value": "'50'",
          "computed": false
        }, {
          "value": "'55'",
          "computed": false
        }, {
          "value": "'60'",
          "computed": false
        }, {
          "value": "'65'",
          "computed": false
        }, {
          "value": "'66'",
          "computed": false
        }, {
          "value": "'70'",
          "computed": false
        }, {
          "value": "'75'",
          "computed": false
        }, {
          "value": "'80'",
          "computed": false
        }, {
          "value": "'85'",
          "computed": false
        }, {
          "value": "'90'",
          "computed": false
        }, {
          "value": "'95'",
          "computed": false
        }, {
          "value": "'100'",
          "computed": false
        }, {
          "value": "'min'",
          "computed": false
        }, {
          "value": "'max'",
          "computed": false
        }, {
          "value": "'auto'",
          "computed": false
        }, {
          "value": "''",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@' '@@, @@hide@@, @@min@@, @@max@@, @@auto@@, @@16@@, @@33@@, @@66@@, and between @@5@@ and @@100@@ in increments of 5"
    },
    "alignLeft": {
      "type": {
        "name": "custom",
        "raw": "exclusiveTextAlignments"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@alignLeft@@ @@alignRight@@ @@alignCenter@@"
    },
    "alignRight": {
      "type": {
        "name": "custom",
        "raw": "exclusiveTextAlignments"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@alignLeft@@ @@alignRight@@ @@alignCenter@@"
    },
    "alignCenter": {
      "type": {
        "name": "custom",
        "raw": "exclusiveTextAlignments"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@alignLeft@@ @@alignRight@@ @@alignCenter@@"
    },
    "pushLeft": {
      "type": {
        "name": "custom",
        "raw": "exclusiveHorizontalValues"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@pushLeft@@ @@pushRight@@ @@pushCenter@@ @@pushHCenter@@"
    },
    "pushRight": {
      "type": {
        "name": "custom",
        "raw": "exclusiveHorizontalValues"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@pushLeft@@ @@pushRight@@ @@pushCenter@@ @@pushHCenter@@"
    },
    "pushHcenter": {
      "type": {
        "name": "custom",
        "raw": "exclusiveHorizontalValues"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@pushLeft@@ @@pushRight@@ @@pushCenter@@ @@pushHCenter@@"
    },
    "pushCenter": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "pushVcenter": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalValues"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@pushTop@@ @@pushBottom@@ @@pushCenter@@ @@pushVcenter@@"
    },
    "pushTop": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalValues"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@pushTop@@ @@pushBottom@@ @@pushCenter@@ @@pushVcenter@@"
    },
    "pushBottom": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalValues"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@pushTop@@ @@pushBottom@@ @@pushCenter@@ @@pushVcenter@@"
    }
  }
};